import Footer from "../footer";
import Navbar from "../header";
import "./GeneralTermsConditions.css";

export default function GeneralTermsConditions() {
    const lastUpdated = "26 June 2026";

    return (
        <>

        <Navbar   menuColor="red" />

        <div className="terms-page">

            <section className="hero">

                <div className="hero-overlay"></div>

                <div className="hero-content">

                    <h1 style={{color:"white"}}>Terms & Conditions</h1>

                    <p  style={{color:"white"}}>
                        Please read these Terms and Conditions carefully before
                        using our platform. By accessing or using our services,
                        you agree to be legally bound by these terms.
                    </p>

                    <div className="updated">
                        Last Updated: <strong>{lastUpdated}</strong>
                    </div>

                </div>

            </section>


            <div className="terms-container">

                <aside className="toc">

                    <h3>Contents</h3>

                    <ul>

                        <li><a href="#acceptance">Acceptance</a></li>

                        <li><a href="#eligibility">Eligibility</a></li>

                        <li><a href="#accounts">Accounts</a></li>

                        <li><a href="#services">Services</a></li>

                        <li><a href="#payments">Payments</a></li>

                        <li><a href="#privacy">Privacy</a></li>

                        <li><a href="#conduct">User Conduct</a></li>

                        <li><a href="#property">Intellectual Property</a></li>

                        <li><a href="#termination">Termination</a></li>

                        <li><a href="#liability">Limitation of Liability</a></li>

                        <li><a href="#law">Governing Law</a></li>

                        <li><a href="#contact">Contact</a></li>

                    </ul>

                </aside>


                <main className="content">

                    <section id="acceptance">

                        <h2>1. Acceptance of Terms</h2>

                        <p>
                            By accessing or using our website, mobile
                            application, or any services offered through our
                            platform, you acknowledge that you have read,
                            understood, and agree to comply with these Terms and
                            Conditions together with our Privacy Policy.
                        </p>

                    </section>


                    <section id="eligibility">

                        <h2>2. Eligibility</h2>

                        <p>
                            You must possess the legal capacity to enter into a
                            binding agreement in accordance with applicable
                            laws. By using our platform, you represent that all
                            information provided is accurate and complete.
                        </p>

                    </section>


                    <section id="accounts">

                        <h2>3. User Accounts</h2>

                        <p>
                            Users are responsible for maintaining the
                            confidentiality of their login credentials and for
                            all activities carried out under their account. Any
                            unauthorized use should be reported immediately.
                        </p>

                    </section>


                    <section id="services">

                        <h2>4. Services</h2>

                        <p>
                            We reserve the right to modify, suspend or
                            discontinue any service, feature or functionality at
                            any time without prior notice where necessary.
                        </p>

                    </section>


                    <section id="payments">

                        <h2>5. Payments & Transactions</h2>

                        <p>
                            Where applicable, all payments must be completed
                            through approved payment channels. Fees are clearly
                            displayed before confirmation of any transaction.
                        </p>

                    </section>


                    <section id="privacy">

                        <h2>6. Privacy</h2>

                        <p>
                            Your personal information is processed in accordance
                            with our Privacy Policy. We employ industry-standard
                            security measures to protect your information.
                        </p>

                    </section>


                    <section id="conduct">

                        <h2>7. Acceptable Use</h2>

                        <ul>

                            <li>No fraudulent activities.</li>

                            <li>No hacking or security breaches.</li>

                            <li>No impersonation.</li>

                            <li>No uploading malicious software.</li>

                            <li>No abuse of our services.</li>

                        </ul>

                    </section>


                    <section id="property">

                        <h2>8. Intellectual Property</h2>

                        <p>
                            All trademarks, logos, graphics, software,
                            databases, content and intellectual property remain
                            the exclusive property of the company unless
                            otherwise stated.
                        </p>

                    </section>


                    <section id="termination">

                        <h2>9. Suspension & Termination</h2>

                        <p>
                            We reserve the right to suspend or permanently
                            terminate accounts that violate these Terms or
                            engage in unlawful activities.
                        </p>

                    </section>


                    <section id="liability">

                        <h2>10. Limitation of Liability</h2>

                        <p>
                            To the fullest extent permitted by law, we shall not
                            be liable for indirect, incidental, special or
                            consequential damages arising from your use of our
                            platform.
                        </p>

                    </section>


                    <section id="law">

                        <h2>11. Governing Law</h2>

                        <p>
                            These Terms shall be governed and interpreted in
                            accordance with the laws applicable within your
                            operating jurisdiction unless otherwise required by
                            law.
                        </p>

                    </section>


                    <section id="contact">

                        <h2>12. Contact Information</h2>

                        <p>
                            For any questions regarding these Terms and
                            Conditions, please contact our support team through
                            the official communication channels provided on our
                            website.
                        </p>

                    </section>

                </main>

            </div>

        </div>

         <Footer/>
        </>
    );
}